import { getErrorJson } from '@mm/utils';
import { showDeleteErrorModal } from '../actions/viewActions';
import PageCRUDActions from '../actions/PageCRUDActions';
import { UNPROCESSABLE_ENTITY, NOT_FOUND } from '@mm/constants/status-codes';
import commonHandler from './common-handler';

export const common = dispatch => async (error, botId) => {
  if (error.status === UNPROCESSABLE_ENTITY || error.status === NOT_FOUND) {
    const parsed = await getErrorJson(error);
    dispatch(showDeleteErrorModal(parsed.errors));
    dispatch(PageCRUDActions.retrieveAll(botId));
    dispatch(PageCRUDActions.unbusy());
  } else {
    dispatch(PageCRUDActions.unbusy());
    commonHandler(dispatch)(error);

    throw error;
  }
};
